/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { connect } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getUserEmail } from 'AdsUI/selectors/AuthSelectors';
import PropTypes from 'prop-types';
import { EntityTypes } from 'AdsUI/lib/Constants';
import { getGlobalFilters } from 'AdsUI/selectors/GlobalFilters';
import makeLoadable from 'AdsUI/lib/makeLoadable';
const ExportReportModalLoader = makeLoadable(() => import('AdsUI/components/ExportReportModal'));

const ExportReportButtonContainer = ({
  entityType,
  loaded,
  userEmail,
  globalFilters,
  dispatch
}) => {
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      onClick: () => setExportDialogOpen(true),
      size: "small",
      use: "tertiary-light",
      disabled: !loaded,
      responsive: false,
      truncate: false,
      "data-test-id": "export-report-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "export.button"
      })
    }), exportDialogOpen && /*#__PURE__*/_jsx(ExportReportModalLoader, {
      entityType: entityType,
      onClose: () => setExportDialogOpen(false),
      userEmail: userEmail,
      globalFilters: globalFilters,
      dispatch: dispatch
    })]
  });
};

ExportReportButtonContainer.propTypes = {
  entityType: PropTypes.oneOf(Object.values(EntityTypes)).isRequired,
  loaded: PropTypes.bool.isRequired
};
export default connect(state => ({
  userEmail: getUserEmail(state),
  globalFilters: getGlobalFilters(state)
}))(ExportReportButtonContainer);